import {
	AfterViewInit,
	Component,
	ElementRef,
	Inject,
	inject,
	signal,
	viewChild
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle
} from '@angular/material/dialog';

@Component({
	selector: 'app-privacy-dialog',
	imports: [
		MatDialogContent,
		MatDialogActions,
		MatDialogClose,
		MatDialogTitle,
		MatButtonModule
	],
	templateUrl: './privacy-dialog.component.html',
	styleUrl: './privacy-dialog.component.scss'
})
export class PrivacyDialogComponent implements AfterViewInit {
	private readonly scrollEndThreshold = 4;
	readonly dialogRef = inject(MatDialogRef<PrivacyDialogComponent>);
	readonly privacyContent =
		viewChild<ElementRef<HTMLElement>>('privacyContent');
	readonly hasReachedEnd = signal(false);

	constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

	ngAfterViewInit(): void {
		setTimeout(() => {
			const content = this.privacyContent()?.nativeElement;
			if (!content) return;

			content.focus();
			this.updateScrollState(content);
		});
	}

	onPrivacyScroll(event: Event): void {
		this.updateScrollState(event.currentTarget as HTMLElement);
	}

	private updateScrollState(content: HTMLElement): void {
		if (this.hasReachedEnd()) return;

		const remainingScroll =
			content.scrollHeight - content.scrollTop - content.clientHeight;
		if (remainingScroll <= this.scrollEndThreshold) {
			this.hasReachedEnd.set(true);
		}
	}
}
